import { render, staticRenderFns } from "./yearbrand.vue?vue&type=template&id=f3146f8c&scoped=true&"
import script from "./yearbrand.vue?vue&type=script&lang=js&"
export * from "./yearbrand.vue?vue&type=script&lang=js&"
import style0 from "./yearbrand.vue?vue&type=style&index=0&id=f3146f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3146f8c",
  null
  
)

export default component.exports